import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { IBanksItem } from './../model/types'

interface IPriorityBanks {
  id: number
  label: string
  banksInner: IBanksItem[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BanksList',
  props: {
  banks: {
    type: Array as PropType<IPriorityBanks[]>,
    required: true
  }
},
  emits: ['onClick'],
  setup(__props, { emit: emits }) {

const props = __props






return { __sfc: true,props, emits }
}

})